'use client';
import { IMobileRectangleContainer } from '~/app/_containers/i-mobile-rectangle-container';
import {
  createDynamicElementId,
  I_MOBILE_SP_SE_INFEED_RECTANGLE,
  I_MOBILE_SP_SE_INFEED_RECTANGLE_SENSITIVE,
  I_MOBILE_PC_SE_INFEED_RECTANGLE,
  I_MOBILE_PC_SE_INFEED_RECTANGLE_SENSITIVE,
} from '~/utils/i-mobile-constants';
import { css } from '@styled-system/css';

export const AdContainer = ({
  listIndex,
  isLastAd,
  canShowGoogleAd,
}: {
  listIndex: number;
  isLastAd: boolean;
  canShowGoogleAd: boolean;
}) => {
  return (
    <IMobileRectangleContainer
      spAdUnit={createDynamicElementId(
        canShowGoogleAd
          ? I_MOBILE_SP_SE_INFEED_RECTANGLE
          : I_MOBILE_SP_SE_INFEED_RECTANGLE_SENSITIVE,
        `between-results-${isLastAd ? 'last' : listIndex}`
      )}
      pcAdUnit={createDynamicElementId(
        canShowGoogleAd
          ? I_MOBILE_PC_SE_INFEED_RECTANGLE
          : I_MOBILE_PC_SE_INFEED_RECTANGLE_SENSITIVE,
        `between-results-${isLastAd ? 'last' : listIndex}`
      )}
      maxW="100%"
      w="100%"
      className={css({
        '& div:has(> *)': {
          my: '24px',
        },
      })}
    />
  );
};
